<nx-header>
  <nx-header-row>
    <nx-header-brand>
      <span class="brand-logo">
        <img src="assets/logos/allianz_logo_with_name.svg" alt="Allianz" height="24" />
      </span>
      <nx-header-app-title>{{ 'Mass Mailing' | transloco }}</nx-header-app-title>
    </nx-header-brand>
    <nx-header-actions>
      <app-accessibility></app-accessibility>
      @if (userName()) {
        <button
          type="button"
          class="header-user-trigger"
          [nxPopoverTriggerFor]="userMenu"
          nxPopoverTrigger="click"
          nxPopoverDirection="bottom"
          [nxPopoverCloseable]="false"
        >
          <span nxAvatar size="small">{{ userInitials() }}</span>
          <span class="header-user-info">
            <span class="header-user">{{ userName() }}</span>
            @if (countryBusinessUnit()) {
              <span class="header-user-sub">{{ countryBusinessUnit() }}</span>
            }
          </span>
        </button>
        <nx-popover #userMenu nxPopoverDirection="bottom">
          <div nxPopoverMainContent>
            <button type="button" class="logout-action" (click)="logout()">
              {{ 'Log out' | transloco }}
            </button>
          </div>
        </nx-popover>
      }
    </nx-header-actions>
  </nx-header-row>
</nx-header>

<nav class="subnav">
  <nx-tab-nav-bar>
    @for (link of subnavLinks; track link.path) {
      <a
        nxTabLink
        [routerLink]="link.path"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive"
      >{{ link.label | transloco }}</a>
    }
  </nx-tab-nav-bar>
</nav>

<main class="shell-main">
  <router-outlet></router-outlet>
</main>
